import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { USER } from '../../../const';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

class LanguageSelector extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.handleSelectLanguage = this.handleSelectLanguage.bind(this);
  }

  static propTypes = {
    selected: PropTypes.string,
    updateLanguage: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    languages: PropTypes.array
  };

  static defaultProps = {
    languages: USER.LANGUAGES
  };

  handleSelectLanguage(event) {
    const { selected, updateLanguage } = this.props;

    if (event.value !== selected) updateLanguage(event.value);
  }

  getSelectedLanguage() {
    const { selected, languages } = this.props;

    if (selected) {
      const selectedLanguage = _.first(
        _.filter(languages, item => {
          return item.value === selected;
        })
      );
      if (selectedLanguage) return selectedLanguage;
    }

    return languages[0];
  }

  renderOptionItems() {
    const { languages } = this.props;
    let items = [];
    languages.forEach((option, i) => {
      const optionSelected = this.getSelectedLanguage().value === option.value;
      items.push(
        <MenuItem
          className="item"
          value={option.value}
          selected={optionSelected}
          key={i}
          onClick={this.handleSelectLanguage.bind(this, option)}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img
              src={require(`../../../images/flags/${option.image}`).default}
              className="language-flag"
              alt="presentation"
            />
            <span style={{ marginLeft: '15px' }}>{option.name}</span>
          </div>
        </MenuItem>
      );
    });

    return items;
  }

  render() {
    const { disabled } = this.props;
    return (
      <TextField
        style={{
          width: '100%',
          border: 'solid 1px #ccc',
          padding: '6px 0 6px 10px',
          borderRadius: '2px',
          color: disabled ? '#999' : '#0a0a0a',
          backgroundColor: disabled ? '#e6e6e6' : '#ffffff'
        }}
        className="text-field-language"
        select
        value={this.getSelectedLanguage().value}
        onChange={this.handleSelectLanguage}
        InputProps={{ disableUnderline: true }}
        disabled={disabled}
      >
        {this.renderOptionItems()}
      </TextField>
    );
  }
}

export default connect()(LanguageSelector);
